module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmYUtfBBc-.bb1e4dc6.bb1e4dc6.woff";